import React, { useContext } from "react";
import { Text, BlockStack, InlineStack } from "@shopify/polaris";
import ClickCollect from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";

const HybridClickCollect = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <div className="hybridClickCollect">
      <BlockStack gap="10">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.clickCollect.title")}
          </Text>
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.clickCollect.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <ClickCollect method="hybridClickCollect" />
    </div>
  );
};

export default HybridClickCollect;
